import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-760a0c10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "verify-card" }
const _hoisted_2 = { class: "mb-10" }
const _hoisted_3 = { class: "form-label fs-5 fw-bold text-dark required" }
const _hoisted_4 = { class: "mb-10" }
const _hoisted_5 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "d-block fw-semobold text-start" }
const _hoisted_9 = { class: "fw-bold d-block fs-4" }
const _hoisted_10 = { class: "mb-10" }
const _hoisted_11 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = ["for"]
const _hoisted_14 = { class: "d-block fw-semobold text-start" }
const _hoisted_15 = { class: "fw-bold d-block fs-4" }
const _hoisted_16 = { class: "mb-10" }
const _hoisted_17 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_18 = { class: "mb-10" }
const _hoisted_19 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_20 = {
  key: 0,
  class: "m-3"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = { class: "pb-3" }
const _hoisted_26 = { class: "fw-bold d-flex align-items-center text-dark ms-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

import { ref, watch, onMounted } from "vue";
import { ConfigCurrencySelections } from "@/core/types/CurrencyTypes";
import { ConfigLeverageSelections } from "@/core/types/LeverageTypes";
import { ErrorMessage, Field } from "vee-validate";
import {
  ConfigAllAccountTypeSelections,
  AccountRoleTypes,
} from "@/core/types/AccountInfos";
import GlobalService from "@/projects/tenant/services/TenantGlobalService";
import { ReferralServiceTypes } from "@/core/types/ReferralServiceTypes";
import { ConfigAllServiceSelections } from "@/core/types/ServiceTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserStart',
  props: {
    verificationDetails: {}
  },
  setup(__props: any) {

const props = __props;


const referInfo = ref<any>({
  referCode: "",
});
const verificationStartData = ref<any>({
  ...props.verificationDetails?.started,
});

watch(
  () => props.verificationDetails,
  () => {
    verificationStartData.value = {
      ...props.verificationDetails?.started,
    };
  }
);

onMounted(() => {
  getReferCodeDetail();
});

const getReferCodeDetail = async () => {
  if (verificationStartData.value.referral !== "") {
    referInfo.value = await GlobalService.getReferralCodeAccountInfo(
      verificationStartData.value.referral
    );
    referInfo.value.serviceFor = getAccountRoleDesignatedByReferCode(
      referInfo.value.serviceType
    );
  }
};

const getAccountRoleDesignatedByReferCode = (serviceType) =>
  ({
    [ReferralServiceTypes.Broker]: AccountRoleTypes.IB,
    [ReferralServiceTypes.Agent]: AccountRoleTypes.IB,
    [ReferralServiceTypes.Client]: AccountRoleTypes.Client,
    // for legacy data
    [200]: AccountRoleTypes.IB,
    [300]: AccountRoleTypes.IB,
    [400]: AccountRoleTypes.Client,
  }[serviceType] ?? AccountRoleTypes.Client);

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("fields.currency")), 1),
      _createVNode(_component_el_select, {
        modelValue: verificationStartData.value.currency,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((verificationStartData.value.currency) = $event)),
        placeholder: "Select",
        name: "currency",
        size: "large"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigCurrencySelections), (item, index) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: index,
              value: item.value,
              label: item.label
            }, null, 8, ["value", "label"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("fields.accountType")), 1),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigAllAccountTypeSelections), (typeItem) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-lg-3 mb-2",
            key: 'type_' + typeItem.value
          }, [
            _createVNode(_unref(Field), {
              modelValue: verificationStartData.value.accountType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((verificationStartData.value.accountType) = $event)),
              type: "radio",
              class: "btn-check",
              name: "accountType",
              value: typeItem.value,
              id: 'kt_create_account_form_account_type_tt' + typeItem.label
            }, null, 8, ["modelValue", "value", "id"]),
            _createElementVNode("label", {
              class: "btn btn-outline btn-outline-default d-flex align-items-center text-dark",
              for: 'kt_create_account_form_account_type_tt' + typeItem.label
            }, [
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(typeItem.label), 1)
              ])
            ], 8, _hoisted_7)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("fields.platform")), 1),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigAllServiceSelections), (serviceItem) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-lg-3 mb-2",
            key: 'serviceId_' + serviceItem.value
          }, [
            _createVNode(_unref(Field), {
              modelValue: verificationStartData.value.serviceId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((verificationStartData.value.serviceId) = $event)),
              type: "radio",
              class: "btn-check",
              name: "serviceId",
              value: serviceItem.id,
              id: 'kt_create_account_form_service_type_tt' + serviceItem.label
            }, null, 8, ["modelValue", "value", "id"]),
            _createElementVNode("label", {
              class: "btn btn-outline btn-outline-default d-flex align-items-center text-dark",
              for: 'kt_create_account_form_service_type_tt' + serviceItem.label
            }, [
              _createElementVNode("span", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(serviceItem.label), 1)
              ])
            ], 8, _hoisted_13)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("fields.leverage")), 1),
      _createVNode(_component_el_select, {
        modelValue: verificationStartData.value.leverage,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((verificationStartData.value.leverage) = $event)),
        name: "leverage",
        size: "large"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigLeverageSelections), (item, index) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: index,
              value: item.value,
              label: item.label
            }, null, 8, ["value", "label"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("fields.referralCode")), 1),
      _createVNode(_component_el_input, {
        modelValue: verificationStartData.value.referral,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((verificationStartData.value.referral) = $event)),
        name: "referral",
        size: "large",
        disabled: verificationStartData.value.referral !== ''
      }, null, 8, ["modelValue", "disabled"]),
      (verificationStartData.value.referral)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createTextVNode(" Open For: "),
            _createElementVNode("b", null, _toDisplayString(_ctx.$t(`type.accountRole.${referInfo.value.serviceFor}`)), 1),
            _hoisted_21,
            _createTextVNode(" Sales Code: "),
            _createElementVNode("b", null, _toDisplayString(referInfo.value.salesAccountCode), 1),
            _hoisted_22,
            _createTextVNode(" Sales Name: "),
            _createElementVNode("b", null, _toDisplayString(referInfo.value.salesName), 1),
            _hoisted_23,
            _createTextVNode(" IB Group: "),
            _createElementVNode("b", null, _toDisplayString(referInfo.value.accountGroupName), 1),
            _hoisted_24
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("h2", _hoisted_26, _toDisplayString(_ctx.$t("tip.ansBelowQuestions")), 1)
    ]),
    _hoisted_27,
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(verificationStartData.value.questions, (value, index) => {
        return (_openBlock(), _createBlock(_component_el_form_item, {
          class: "row",
          label: 
          {
            q1: _ctx.$t('tip.verificationQ1'),
            q2: _ctx.$t('tip.verificationQ2'),
            q3: _ctx.$t('tip.verificationQ3'),
            q4: _ctx.$t('tip.verificationQ4'),
          }[index]
        ,
          key: index,
          prop: 'questions.' + index
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: verificationStartData.value.questions[index],
              "onUpdate:modelValue": ($event: any) => ((verificationStartData.value.questions[index]) = $event),
              class: "row mt-11 w-100"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: true,
                  value: true,
                  border: "",
                  class: "col-4 col-lg-2 ms-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.yes")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: false,
                  value: true,
                  border: "",
                  class: "col-4 col-lg-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.no")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1032, ["label", "prop"]))
      }), 128))
    ])
  ]))
}
}

})